<mat-toolbar classs="container-background-color mat-elevation-z6">
  <a routerLink="dashboard"><h1>TecAlliance Legal Blacklist</h1></a>
  <div class="spacer"></div>
  <a mat-fab extended routerLink="./add-infringement">
    <mat-icon>add</mat-icon>
    Add Infringement
  </a>
  <div class="spacer"></div>
  <button mat-button *ngIf="(authState.authState$ | async)?.isAuthenticated" type="button"
          [disabled]="signingOut"
          (click)="logout()">
    {{ signingOut ? 'Logout…' : 'Logout' }}
  </button>
</mat-toolbar>
